<template>
    <div style="background-color:#fff;line-height: 0;">
        <div class="stock" v-if="purchased == 1">


            <!-- 新智能诊股内容 -->
            <div class="phone_znzg" aria-label="智能诊股行情逻辑" v-if="has_ai_report">
                <section class="section-stack">
                

                    <!-- 行情概述 -->
                    <article id="overview" class="overview" v-if="overviewContent">
                    <h2>行情概述</h2>
                    <p v-html="overviewContent"></p>
                    </article>


                    <!-- 主要章节 -->
                    <section id="logicList" class="section-stack">
                        <details
                        v-for="(section, index) in sections"
                        :key="index"
                        class="logic-card"
                        open=""
                        >
                        <summary aria-expanded="true">
                            <span class="icon" aria-hidden="true">
                            <img :src="section.icon" alt="">
                            </span>
                            <h3 class="summary-title">{{ section.title }}</h3>
                            <span class="chevron" aria-hidden="true"></span>
                        </summary>
                        <div class="logic-body" style="height: auto; opacity: 1;">
                            <!-- 引导语：遍历数组，每个段落一个 <p> -->
                                <p 
                                    v-for="(paragraph, idx) in section.intro" 
                                    :key="paragraph"
                                    class="section-intro"
                                    v-html="paragraph"
                                    ></p>
                            <p
                            v-for="(item, idx) in section.items"
                            :key="idx"
                            class="numbered-item"
                            >
                            <span class="item-marker">{{ idx + 1 }}.</span>
                            <span class="item-copy" v-html="item"></span>
                            </p>
                        </div>
                        </details>
                    </section>

                    <!-- 风险提醒独立模块 - 使用 article 结构 -->
                    <article v-if="riskSection" id="riskCard" class="risk-card"
                    :class="{ open: isRiskOpen }"
                    
                    >
                    <button
                        id="riskToggle"
                        class="risk-head"
                        type="button"
                        aria-expanded="true"
                        aria-controls="riskList"
                        @click="toggleRisk"
                    >
                        <span class="icon" aria-hidden="true">
                        <img src="https://cdncos.aigupiao.com/assets/pc/img/2023/figma-assets/icon-risk.svg" alt="">
                        </span>
                        <h3>{{ riskSection.title }}</h3>
                        <span class="chevron" aria-hidden="true"></span>
                    </button>
                    <div id="riskList" class="risk-list" :style="riskListStyle">
                        <div
                        v-for="(item, idx) in riskSection.items"
                        :key="idx"
                        >
                        <p class="risk-item" v-html="item"></p>
                        <span
                            v-if="idx < riskSection.items.length - 1"
                            class="risk-divider"
                            aria-hidden="true"
                        ></span>
                        </div>
                    </div>
                    </article>




                </section>
            </div>



            <div class="data_update" v-if="!has_ai_report">
                <span>数据更新</span>&nbsp;&nbsp;<span>{{update_time}}</span>
            </div>
            <div class="company_box" v-if="!has_ai_report">
                <div class="grade_box">
                    <div class="company_chart">
                        <company_chart
                                :quality="Math.ceil(overview.quality_score)"
                                :institution="Math.ceil(overview.institution_score)"
                                :industry="Math.ceil(overview.industry_score)"
                                :valuation="Math.ceil(overview.valuation_score)"
                                :trend="Math.ceil(overview.trend_score)"
                        />
                    </div>
                    <div class="grade">
                        <div class="grade_name">综合评分</div>
                        <div class="grade_number">{{Math.ceil(overview.total_score)}}</div>
                        <div class="grade_word">击败了<span>{{Math.ceil(overview.beat_percent*100)}}%</span>的个股</div>
                    </div>
                </div>
                <div class="company_quality">
                    <div class="company_quality_title">
                        <img src="https://cdncos.aigupiao.com/assets/wap/img/znzg/gs2.png"/>
                        <span class="big_title_common">公司质地</span>
                    </div>
                    <div class="company_quality_content">
                        <ul v-if="quality.msgs">
                            <li v-for="item in quality.msgs">
                                <div class="point"></div>
                                <p>
                                    <span v-for="i in item":class="{ 'point_tag': i.mark  }" >{{i.str}}</span>
                                </p>
                            </li>
                        </ul>
                        <ul v-if="!quality.msgs">
                            <li>
                                <div class="point"></div>
                                <p>
                                    暂无公司质地
                                </p>
                            </li>
                        </ul>
                        <div class="company_tag" v-if="quality.tags">{{quality.tags}}</div>
                    </div>
                </div>
                <div class="company_quality">
                    <div class="company_quality_title">
                        <img src="https://cdncos.aigupiao.com/assets/wap/img/znzg/dq2.png"/>
                        <span class="big_title_common">短期策略</span>
                    </div>
                    <div class="company_quality_content">
                        <ul v-if="strategy.msgs">
                            <li v-for="item in strategy.msgs">
                                <div class="point blue"></div>
                                <p>
                                    <span v-for="i in item">{{i.str}}</span>
                                </p>
                            </li>
                        </ul>
                        <ul v-if="!strategy.msgs">
                            <li>
                                <div class="point blue"></div>
                                <p>
                                    暂无短期策略
                                </p>
                            </li>
                        </ul>
                        <div class="company_tag tag_blue" v-if="strategy.tags">{{strategy.tags}}</div>
                    </div>
                </div>
            </div>


            <div class="data_box" v-if="!has_ai_report && znzg_in">
                <div class="data_box_title"><span class="big_title_common big_title_margin">行业题材</span></div>
                <div class="target_price_p" v-if="industryInfo.length > 0">
                    <h1>行业<span>取自申万一级行业和二级行业</span></h1>

                    <div class="plate_wrap">
                        <div class="plate_i" :class="[item.chg > 0 ?'red':'',item.chg < 0 ?'green':'']" v-for="item in industryInfo">
                            <h1>{{item.industryName}}</h1>
                            <span>{{parseF(item.chg)}}%</span>
                        </div>
                    </div>

                </div>
                <div class="target_price_p"  v-if="changeAreaTheme.length > 0">
                    <h1>题材<span>取最相关和有异动的题材</span></h1>

                    <div class="plate_wrap">
                        <div class="plate_i" :class="[item.chgPct > 0 ?'red':'',item.chgPct < 0 ?'green':'']" v-for="item in changeAreaTheme">
                            <i v-if="item.tag">{{item.tag}}</i>
                            <h1>{{item.themeName}}</h1>
                            <span>{{parseF(item.chgPct) }}%</span>
                        </div>
                    </div>
                </div>
                <div class="target_price_p2">
                    <p v-html="industryComment.replace(/<\d{6}>/g,'')"></p>
                    <p v-if="themeComment">
                        <span class="red">异动</span>
                        <span v-html="themeComment.replace(/<\d{6}>/g,'')"></span>
                    </p>
                </div>

            </div>

            <div class="data_box" v-if="!has_ai_report">
                <div class="data_box_title"><span class="big_title_common big_title_margin">财务点评</span></div>
                <div class="goodness">
                    <div class="goodness_title">
                        <img src="https://cdncos.aigupiao.com/assets/wap/img/znzg/smile.png">
                        <span>财务亮点</span>
                    </div>
                    <div class="goodness_content">
                        <ul v-if="finance_comment.highlight">
                            <li v-for="item in highlight"><div class="goodness_point goodness_content_blue"></div>{{item}}</li>
                        </ul>
                        <ul v-if="!finance_comment.highlight">
                            <li><div class="goodness_point goodness_content_blue"></div>暂无财务亮点</li>
                        </ul>
                    </div>
                </div>
                <div class="goodness">
                    <div class="goodness_title">
                        <img src="https://cdncos.aigupiao.com/assets/wap/img/znzg/cry.png">
                        <span class="goodness_title_blue">风险提示</span>
                    </div>
                    <div class="goodness_content">
                        <ul v-if="finance_comment.risk">
                            <li v-for="item in risk"><div class="goodness_point goodness_content_blue"></div>{{item}}</li>
                        </ul>
                        <ul v-if="!finance_comment.risk">
                            <li><div class="goodness_point goodness_content_blue"></div>暂无风险提示</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="data_box" v-if="!has_ai_report">
                <div class="data_box_title"><span class="big_title_common big_title_margin">机构目标价</span></div>
                <div class="target_price">
                    <div class="target_price_content" v-if="insTargetPrice.comment_list ">
                        <span v-for="item in insTargetPrice.comment_list" :class="{'span_tag' : item.mark}">{{item.str}}</span>
                    </div>
                    <div class="target_price_content target_price_content_none" v-if="!insTargetPrice.comment_list ">
                        <span>暂无机构目标价</span>
                    </div>
                    <div class="target_price_chart" ref="chart" v-if="insTargetPrice.comment_list ">
                        <div class="target_price_chart_box" style="top: 0;" v-if="insTargetPrice.pct && insTargetPrice.avg - insTargetPrice.max != 0">
                            <div>最高目标价</div><div>{{insTargetPrice.max}}元</div>
                        </div>
                        <div class="target_price_chart_box" :style="{ bottom : min_bottom }" v-if="insTargetPrice.pct && insTargetPrice.avg - insTargetPrice.min !=0">
                            <div>最低目标价</div><div>{{insTargetPrice.min}}元</div>
                        </div>
                        <div :class="['target_price_chart_box',!insTargetPrice.pct ? 'target_price_chart_box_blue':'target_price_chart_box_red']"
                             :style="{top : avg_top }">
                            <div>目标均价</div><div :class="[!insTargetPrice.pct ? 'target_font_blue':'target_font_red']">{{insTargetPrice.avg}}元</div>
                        </div>
                        <div :class="['target_price_chart_box',!insTargetPrice.pct ? 'target_price_chart_box_red':'target_price_chart_box_blue']"
                             :style="{top : cur_top  }">
                            <div>当前价</div><div :class="[!insTargetPrice.pct ? 'target_font_red':'target_font_blue']">{{insTargetPrice.cur}}元</div>
                        </div>
                        <div class="target_price_chart_squre" ref="chartsqure" v-if="insTargetPrice.pct"
                             :style="{top : squre_top , height : squre_height}"
                        >
                            <div class="target_price_chart_squre_text">目标涨幅{{insTargetPrice.pct}}</div>
                            <div class="target_price_chart_squre_tag">
                                <div></div><div></div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="data_box">
                <div class="data_box_title"><span class="big_title_common big_title_margin">机构持股比例</span></div>
                <div class="target_price">
                    <div class="target_price_content" v-if="insHoldRatio.hs">
                        <span v-for="item in insHoldRatio.hs" :class="{'span_tag' : item.mark}">{{item.str}}</span>
                    </div>
                    <div class="target_price_content target_price_content_none" v-if="!insHoldRatio.hs">
                        暂无机构持股比例
                    </div>
                    <div class="ratio_chart" v-if="insHoldRatio.hs">
                        <RatioChart :price="insHoldRatio.price" :ratio="insHoldRatio.ratio" />
                    </div>
                </div>
            </div>
            <div class="data_box">
                <div class="data_box_title"><span class="big_title_common big_title_margin">机构评级</span></div>
                <div class="target_price" v-if="insGradeResult.grade > 0">
                    <div class="target_price_content">{{insGradeResult.comment}}</div>
                    <div class="target_price_content_chart">
                        <div class="target_price_content_chart_pos_box">
                            <div class="target_price_content_chart_pos" :style="{left:price_left+'%' }"></div>
                        </div>
                        <div class="target_price_content_chart_wrap">
                            <div class="target_price_content_chart_box">
                                <div class="target_price_content_chart_box_color"></div>
                                <div class="target_price_content_chart_box_word">卖出</div>
                            </div>
                            <div class="target_price_content_chart_box">
                                <div class="target_price_content_chart_box_color color2"></div>
                                <div class="target_price_content_chart_box_word">减持</div>
                            </div>
                            <div class="target_price_content_chart_box">
                                <div class="target_price_content_chart_box_color color3"></div>
                                <div class="target_price_content_chart_box_word">中性</div>
                            </div>
                            <div class="target_price_content_chart_box">
                                <div class="target_price_content_chart_box_color color4"></div>
                                <div class="target_price_content_chart_box_word">增持</div>
                            </div>
                            <div class="target_price_content_chart_box">
                                <div class="target_price_content_chart_box_color color5"></div>
                                <div class="target_price_content_chart_box_word">买入</div>
                            </div>
                        </div>
                    </div>
                    <div class="grade_table">
                        <div class="grade_table_title">
                            <span>名称</span>
                            <span>日期</span>
                            <span>评级</span>
                        </div>
                        <ul>
                            <li v-for="item in insGradeResult.item_list">
                                <span>{{item.name}}</span>
                                <span>{{item.date}}</span>
                                <span :class="[item.content == '买入' ? 'grade_red': (item.content == '增持' ? 'grade_yellow' : 'grade_green' )]">{{item.content}}</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="target_price" v-if="insGradeResult.grade == 0">
                    <div class="target_price_content target_price_content_none">暂无机构评级</div>
                </div>
            </div>
            <div class="data_box" v-if="!has_ai_report">
                <div class="data_box_title"><span class="big_title_common big_title_margin">主力资金</span></div>
                <div class="target_price" v-if="moneyGraph.hs">
                    <div class="target_price_content">{{moneyGraph.hs}}</div>
                    <mainCapital
                            :xl="parseInt(mainCapital1.xl)"
                            :l="parseInt(mainCapital1.l)"
                            :m="parseInt(mainCapital1.m)"
                            :s="parseInt(mainCapital1.s)"
                    >

                    </mainCapital>
                </div>
                <div class="target_price" v-if="!moneyGraph.hs">
                    <div class="target_price_content target_price_content_none">暂无主力资金</div>
                </div>
            </div>
            <div class="data_box" v-if="!has_ai_report">
                <div class="data_box_title"><span class="big_title_common big_title_margin">技术分析</span></div>
                <div class="target_price">
                    <div class="target_price_content" v-if="techAspect.aspect_comment">{{techAspect.aspect_comment}}</div>
                    <div :class="[!techAspect.aspect_comment && !techAspect.k_node_list ? 'target_price_content_none':'' ,'target_price_content']" v-if="!techAspect.aspect_comment">暂无技术分析</div>
                <div class="technical_analysis" v-if="techAspect.k_node_list">
                    <div class="technical_analysis_title">
                        <img src="https://cdncos.aigupiao.com/assets/wap/img/znzg/tri.png"/>
                        压力与支撑</div>
                    <div class="technical_analysis_chart">
                        <Kchart :k_node_list="techAspect.k_node_list" />
                    </div>
                </div>
                <div class="technical_analysis" v-if="0 && techAspect.signals">
                    <div class="technical_analysis_title">
                        <img src="https://cdncos.aigupiao.com/assets/wap/img/znzg/tri.png"/>
                        当前技术信号/形态
                    </div>
                    <div class="technical_analysis_box">
                        <span v-for="item in techAspect.signals" :class="[item.type == 'SHORT' ? 'down_span':(item.type == 'HOLD' ? 'down_span':'hold_span')]">
                            {{item.name}}
                        </span>
                    </div>
                </div>
                </div>
            </div>
            <div class="data_box">
                <div class="data_box_title"><span class="big_title_common big_title_margin">龙虎榜</span></div>
                <div class="target_price">
                    <div class="target_price_content longhu" v-if="dragonTiger.hs != '最近30日未登上龙虎榜'">{{dragonTiger.hs}}</div>
                    <div class="longhu_box" v-if="dragonTiger.hs != '最近30日未登上龙虎榜'">
                        <div class="longhu_range">
                            <div>{{dragonTiger.rank_date}}</div>
                            <div class="longhu_rise" v-if="dragonTiger.chg_pct >= 0">
                                <img src="https://cdncos.aigupiao.com/assets/wap/img/znzg/zhang.png" />
                                <span>涨幅：</span>
                                <span class="longhu_rise_red">+{{(dragonTiger.chg_pct*100).toFixed(2)}}%</span>
                            </div>
                            <div class="longhu_rise longhu_fall" v-if="dragonTiger.chg_pct < 0">
                                <img src="https://cdncos.aigupiao.com/assets/wap/img/znzg/die.png" />
                                <span>跌幅：</span>
                                <span class="longhu_rise_green">{{(dragonTiger.chg_pct*100).toFixed(2)}}%</span>
                            </div>
                        </div>
                        <div class="longhu_total">
                            <div><p>买入(万元)</p><p class="total_num total_num_buy">{{(dragonTiger.total_buy/10000).toFixed(2)}}</p></div>
                            <div><p>卖出(万元)</p><p class="total_num total_num_sell">{{(dragonTiger.total_sell/10000).toFixed(2)}}</p></div>
                            <div><p>净买(万元)</p><p class="total_num total_num_net">{{(dragonTiger.total/10000).toFixed(2)}}</p></div>
                        </div>
                        <div class="longhu_reason">上榜理由：{{dragonTiger.reason}}</div> 
                        <div class="expand" v-show="longhu_expand == 0" @click="expand"><img src="https://cdncos.aigupiao.com/assets/wap/img/znzg/open.png"/>展开</div>
                        <div v-show="longhu_expand == 1">
                            <div class="longhu_table">
                                <div class="longhu_table_title">
                                    <div class="longhu_table_buy5 longhu_red">买入前五</div>
                                    <div>买入(万)</div><div class="longhu_table_sell">卖出(万)</div>
                                </div>
                                <ul>
                                    <li v-for="item in dragonTiger.buy_list">
                                        <div class="longhu_table_buy5">{{item.sales}}</div>
                                        <div class="longhu_red">{{(item.buyValue/10000).toFixed(2)}}</div>
                                        <div class="longhu_table_sell longhu_blue">{{(item.sellValue/10000).toFixed(2)}}</div>
                                    </li>
                                </ul>
                            </div>
                            <div class="longhu_table">
                                <div class="longhu_table_title">
                                    <div class="longhu_table_buy5 longhu_green">卖出前五</div><div>买入(万)</div><div class="longhu_table_sell">卖出(万)</div>
                                </div>
                                <ul>
                                    <li v-for="item in dragonTiger.sell_list">
                                        <div class="longhu_table_buy5">{{item.sales}}</div>
                                        <div class="longhu_red">{{(item.buyValue/10000).toFixed(2)}}</div>
                                        <div class="longhu_table_sell longhu_blue">{{(item.sellValue/10000).toFixed(2)}}</div>
                                    </li>
                                </ul>
                            </div>
                            <div class="expand" v-show="longhu_expand == 1" @click="expand"><img src="https://cdncos.aigupiao.com/assets/wap/img/znzg/close.png"/>收起</div>
                        </div>
                    </div>
                    <div class="target_price_content target_price_content_none " v-if="dragonTiger.hs == '最近30日未登上龙虎榜'">最近30日未登上龙虎榜</div>
                </div>
            </div>


            <div class="data_box" v-if="!has_ai_report">
                <div class="data_box_title"><span class="big_title_common big_title_margin">融资融券</span></div>
                <div class="target_price">
                    <div class="target_price_content" v-if="finSecGraph.fin_comment">{{finSecGraph.fin_comment}}</div>
                    <div class="target_price_content target_price_content_none" v-if="!finSecGraph.fin_comment">暂无融资融券</div>
                    <div class="financing_chart" v-if="finSecGraph.fin_comment">
                        <FinancingChart :node_list="finSecGraph.node_list" :sum_list="finSecGraph.sum_list" :name="name" />
                    </div>
                </div>
            </div>




            <div class="risk_statement">
                智能诊断内容基于大数据智能生成，不构成投资建议，风险自担
            </div>
        </div>
        <!-- 未购买 -->
        <div class="not_purchased" v-if="purchased == 0">
            <div class="not_purchased_box">
                <div class="not_name">{{name}}({{symbol}})</div>
                <div class="not_situation">
                    <span></span>&nbsp;&nbsp;&nbsp;<span></span>
                </div>
                <div class="not_trait">
                    <div>
                        <div class="not_trait_img">
                            <img class="img_one" src="https://cdncos.aigupiao.com/assets/wap/img/znzg/dpzd2.png" />
                        </div>
                        <div class="not_trait_word">大数据诊断</div>
                        <div class="not_trait_word">精准解析个股状态</div>
                    </div>
                    <div>
                        <div class="not_trait_img">
                            <img class="img_two" src="https://cdncos.aigupiao.com/assets/wap/img/znzg/rgzn2.png" />
                        </div>
                        <div class="not_trait_word">人工智能技术</div>
                        <div class="not_trait_word">多因子深度诊断</div>
                    </div>
                    <div>
                        <div class="not_trait_img">
                            <img class="img_three" src="https://cdncos.aigupiao.com/assets/wap/img/znzg/jyjy2.png" />
                        </div>
                        <div class="not_trait_word">智能评分系统</div>
                        <div class="not_trait_word">AI系统独有持仓建议</div>
                    </div>
                </div>
                <!--task-->
                <a v-if="!is_from_agq && !is_from_kd && !is_from_zf" :href="'?kind=XNZG&stock_code='+symbol+'#AiGuPiao_ThirdPay'" class="not_btn">
                    查看此诊股 只需30金币
                </a>
                <p v-if="!is_from_agq && !is_from_kd && !is_from_zf">购买后24小时内有效</p>

                <a v-if="is_from_agq" href="javascript:;" class="not_btn">
                    开通任意圈子会员 即可免费使用
                </a>
                <a v-if="is_from_kd" href="javascript:;" class="not_btn">
                    开通任意星球会员 即可免费使用
                </a>
                <a v-if="is_from_zf" href="javascript:;" class="not_btn">
                    开通任意圈子会员 即可免费使用
                </a>

                <p v-if="is_from_agq" class="agq">
                    有疑问请联系
                    <a href="javascript:;" @click="funToApp('srGoToContact',[])">爱股圈小秘书</a>
                </p>
                <p v-if="is_from_kd" class="agq">
                    有疑问请联系
                    <a href="javascript:;" @click="funToApp('srGoToContact',[])">星球小秘书</a>
                </p>
                <p v-if="is_from_zf" class="agq">
                    有疑问请联系
                    <a href="javascript:;" @click="funToApp('srGoToContact',[])">中富通小秘书</a>
                </p>
            </div>
        </div>
        <!-- 暂无诊股 -->
        <div class="none" v-if="purchased == 2">
            <div class="none_img"><img :src="require('@/assets/images/znzg/none.png')"></div>
            <p>暂无此诊股...</p>
        </div>
    </div>

</template>

<script>
import "@/utils/flexible";
import company_chart from './charts/Company_chart.vue'
import RatioChart from './charts/RatioChart.vue'
import Kchart from './charts/Kchart.vue'
import FinancingChart from './charts/FinancingChart.vue'
import MainCapital from './charts/MainCapital.vue'
import Api from "@/api/Intelligent_diagnosis_stock/index";
    import * as echarts from 'echarts'
    export default {
        name: "index",
        components:{
          company_chart,
          RatioChart,
          Kchart,
          FinancingChart,
          MainCapital
        },
        data(){
            return{
                user_id:this.$route.params.uid,
                symbol:this.$route.params.id,
                name:decodeURI(this.$route.params.name),
                purchased : 3, //是否为购买，1为是,0为未购买，2是暂无此诊股
                longhu_expand : 0, //是否已经展开龙虎榜
                overview:'',// 综合得分
                quality:'', //公司质地
                strategy:'',// 短期策略
                dragonTiger:'',//龙虎榜
                finSecGraph:'', //融资融券
                moneyGraph:'', //主力资金
                techAspect:'', //技术分析
                insGradeResult:'',//  机构评级
                insHoldRatio:'',//  机构持股比例
                insTargetPrice:'',//机构目标价
                finance_comment:'',//财务点评
                highlight:'',//财务亮点
                risk:'',//风险提示
                update_time:'',//更新时间
                avg_top :0,
                cur_top :0,
                avg_bottom :0,
                min_bottom :0,
                squre_height:0,
                squre_top:0,
                mainCapital1:{},//主力资金
                price_left:0,

                is_from_agq:false,//来自爱股圈
                is_from_kd: false, // 来自科德
                is_from_zf: false, // 来自中福

                znzg_in :false,
                changeAreaTheme:[],
                industryInfo:[],
                industryComment:'',
                themeComment:'',


                sections: [],
                riskSection: null,
                overviewContent:'',
                has_ai_report:true,//存在ai报告
                isRiskOpen: true // 默认展开
            }

        },
        created() {
            this.is_from_agq = location.href.includes('is_from_agq');
            this.is_from_kd = location.href.includes('is_from_kd');
            this.is_from_zf = location.href.includes("is_from_zf");
        },
        mounted(){


            





            let data = {user_id:this.user_id, symbol:this.symbol};
            if(this.is_from_agq){
                data.is_from_agq = 'yes';
            }
            if(this.is_from_kd) {
                data.is_from_kd = 'yes'
            }
            if(this.is_from_zf) {
                data.is_from_zf = "yes";
            }

            
            this.stockDetail(data);
            //todo 开发调试时注释
            // let data2 ={
            //         ai_report:{
            //         "content": "# 华润双鹤（600062）近期震荡分化 政策与新业务预期主导盘面（截至2026年7月15日）\n华润双鹤近期整体呈现窄幅震荡、多空力量分歧的运行特征，7月以来单日涨跌幅均未超过1%，7月14日收盘涨幅为0.96%，对应成交额1.57亿元。**核心驱动来自《国民健康“十五五”规划》对创新药、合成生物赛道的政策利好催化**，而压制因素主要源于一季度营收阶段性下滑带来的基本面扰动，当前资金整体呈现阶段性流出态势，盘面交易主线围绕政策红利与新业务落地预期展开。\n\n## 一、政策催化：行业顶层规划匹配公司转型方向（短期情绪支撑）\n2026年7月发布的《国民健康“十五五”规划》提出全链条支持创新药、核酸药物、合成生物制造等领域发展，多项政策方向与华润双鹤现有业务布局高度契合。\n- 政策明确优化siRNA小核酸药物、罕见病药优先审评通道，公司DC6001等中美双报创新品种有望缩短上市周期，加快后续医保落地节奏。\n- 规划重点扶持儿童用药、生物制造产业，公司现有巯嘌呤微片等儿科制剂可巩固细分赛道优势，在建合成生物项目可享受专项补贴与税收优惠，市场对其新业务落地进度的关注度明显提升。\n\n## 二、基本面现状：一季度营收阶段性下滑，核心业务保持稳健\n据公司2026年4月披露的一季度经营数据公告，当期主营业务合计营收27.89亿元，同比下滑8.62%，整体毛利率为59.00%，同比小幅下降1.46个百分点。\n- 分板块来看，输液业务营收同比下滑15.01%，非输液业务营收同比下滑6.47%，但两大板块毛利率均保持在55%以上，盈利韧性未出现明显弱化。\n- 公司2026年3月披露的电商体系建设进展显示，全国异地分仓48小时到货率提升至57%-73%，北京地区180家医疗单位实现24小时配送，OTC渠道覆盖能力持续优化。\n\n## 三、新业务进展：合成生物板块逐步落地，市场预期持续升温\n据2026年6月公司披露的投资者关系活动记录表，合成生物板块已实现阶段性技术突破，成为市场重要交易主线。\n- 目前14-丁二胺已达成百吨级量产，计划2026年12月底落地千吨级产能，后续可根据下游订单快速扩产至万吨级别，与沃特股份合作的生物基PA46材料可应用于新能源汽车零部件领域。\n- 公司已打通从基因编辑、菌种筛选到规模化发酵的全链条技术平台，行业普遍存在的中试放大“死亡之谷”问题已得到针对性解决，后续中试新产品预计2026年底至2027年初陆续投放市场。\n\n## 四、资金面：阶段性资金流出，筹码整体呈分散态势\n截至2026年7月14日数据，近期资金整体呈现小幅流出特征，未出现明显的单边加仓或减仓信号。\n- 近5个交易日主力资金累计净流出1166.36万元，近20个交易日累计净流出1.09亿元，7月14日当日主力资金净流入118.25万元，短期流出节奏有所放缓。\n- 当前市场平均筹码成本为18.30元，主力持仓占比仅4.27%，筹码分布较为分散，当前股价靠近17.17元压力位，尚未形成明确的突破趋势。\n\n## 风险提示\n- 2026年一季度公司输液、非输液板块营收均出现同比下滑，若下半年终端需求恢复不及预期，存在业绩继续承压的可能。\n- 合成生物新业务中试产品落地进度、下游客户拓展情况仍存在不确定性，相关产能释放后的盈利贡献尚未经过验证。\n- 公司烟酰胺原料药收入占总营收比例不足0.1%，未开展NMN相关业务，市场对相关热点概念的炒作存在预期透支风险。\n- 医药行业带量采购、医保谈判政策持续推进，公司核心仿制药品种存在降价压力，可能对后续毛利率造成扰动。\n\n信息仅供参考，不构成投资建议。",
            //         "model": "doubaoseed2.0-lite",
            //         "report_date": "2026-07-15",
            //         "update_at": "2026-07-15 14:31:43"
            //     },
            //     ai_report:{
            //     "content": "# 皖维高新（600063）6-7月区间异动：两次涨停后多空博弈加剧（截至2026年7月15日）\n皖维高新在2026年6月上旬至7月初走出两轮涨停行情，先后在6月5日、7月1日触及涨停，核心驱动来自**高端新材料扩产+定增方案优化**的长期成长逻辑，叠加一季报盈利韧性支撑。7月上旬后股价进入多空博弈阶段，围绕定增定价机制调整形成明显分歧，资金层面北向资金、机构席位与短线资金交互博弈，是当前化工新材料板块中兼具业绩确定性和事件催化的标的。\n\n## 一、两轮涨停核心催化：定增投向高端产能，彰显长期成长逻辑\n公司30亿元定增方案全部投向20万吨/年乙烯法功能性PVA树脂、年产3000万平方米高世代面板PVA光学膜项目，直接瞄准国内高端PVA材料进口替代赛道，契合产业链自主可控政策方向。\n- 控股股东全额现金认购且锁定期设置为3年，既保障募投资金足额落地，也向市场传递出对公司长期发展的明确信心，打消了此前市场对定增资金来源的疑虑。\n- 业务端持续聚焦核心主业，吸收合并皖维皕盛完成PVB产业链整合，年降本超3000万元，同步剥离非主业小贷股权回笼资金，主业集中度进一步提升。\n\n## 二、业绩基本面支撑：盈利端保持韧性，机构预测增速明确\n2025年公司归母净利润达4.34亿元，同比增长17.39%；2026年一季度实现营业收入19.45亿元，归母净利润1.36亿元，同比增长15.68%，在营收小幅波动的背景下盈利端展现较强韧性。\n- 近6个月共有8家机构发布相关研报，对公司2026年净利润预测均值达7.62亿元，同比增速预期超75%，其中4家给予“买入”评级，机构整体对其全年盈利表现偏乐观。\n- 作为全球PVA行业龙头，公司在国内PVA产能占比处于领先水平，后续功能性PVA、光学膜产能落地后，产品结构升级将进一步推高盈利中枢。\n\n## 三、资金面博弈：北向与游资合力拉涨，融资盘同步加仓\n6月5日皖维高新因日涨幅偏离值达10.78%登上沪市龙虎榜，当日资金交易活跃度显著提升，是两轮涨停行情的直接推手。\n- 当日全市场成交额达24.63亿元，换手率14.85%，龙虎榜席位合计净买入8816.30万元，其中沪股通专用席位净买入3569.89万元，高盛、华鑫证券上海席位等机构及游资席位同步大额买入。\n- 当日主力资金净流入3.07亿元，近5日主力资金累计净流入1.59亿元；融资余额较前5日增加1.13亿元，增幅达16.93%，融资盘同步加仓放大了股价弹性。7月1日第二次涨停时，单日成交额也达到13.92亿元，资金承接力度较强。\n\n## 四、多空分歧导火索：定增定价机制调整引发博弈\n2026年6月30日公司发布定增预案修订公告，将原固定底价发行规则调整为按发行前20个交易日市价的8折定价，这一规则变动直接成为7月上旬多空博弈的核心焦点。\n- 部分市场观点认为，定增定价调整窗口期存在刻意压低20日均价的交易动机，叠加同期板块整体平稳、个股逆势波动，引发资金分歧。\n- 该修订后的定增方案仍需上交所审核通过及证监会注册，后续定价基准日的明确将直接影响股价短期波动方向，是市场当前重点关注的节点。\n\n## 风险提示\n- 定增项目尚需上交所审核及证监会注册，存在审批进度不及预期或发行失败的风险，高端PVA光学膜项目后续产能释放节奏仍待验证。\n- PVA行业产能投放、原材料价格波动可能导致产品毛利率下行，直接影响全年盈利兑现情况，与机构预测的高增速存在偏差。\n- 7月上旬股价异动已引发市场对定增窗口期交易行为的高度关注，后续若出现异常波动可能触发交易所问询，带来短期情绪冲击。\n- 前期融资盘加仓幅度较高，若后续股价走弱，可能引发融资盘集中平仓，放大短期调整幅度。\n\n信息仅供参考，不构成投资建议。",
            //     "model": "doubaoseed2.0-lite",
            //     "report_date": "2026-07-15",
            //     "update_at": "2026-07-15 14:32:24"
            //     },
            //     ai_report:{
            //     "content": "# 国投资本（600061）近期震荡分化 业绩支撑下的估值修复进程（截至2026年7月15日）\n截至2026年7月14日收盘，国投资本报收6.52元，当日微涨0.62%，近期整体呈现**窄幅震荡、业绩与政策预期交织**的走势，市场交易主线围绕旗下金融子公司盈利超预期、证券行业政策催化展开，同时叠加股份回购的市值管理托底动作。公司股价未出现单边大幅涨跌，多空双方围绕内在价值回归节奏存在分歧。\n\n## 一、核心基本面支撑：子公司信托业绩高增验证盈利韧性\n国投资本旗下核心金融子公司国投泰康信托披露的2026年半年度未经审计财报显示，上半年实现净利润297,360.54万元，同比增长33.44%，营业总收入同比增长28.85%。该数据大幅跑赢行业平均增速，成为近期支撑公司估值的核心基本面锚点。\n公司2025年全年归母净利润32.79亿元，同比增长21.71%；2026年第一季度归母净利润7.66亿元，同比增长12.63%，连续两个报告期保持双位数正增长，经营质量保持稳健。国投资本在7月8日互动平台明确表示，当前二级市场表现未能充分反映公司实际经营业绩与资产质量，向市场传递了对自身基本面的信心。\n\n## 二、市值管理托底：累计超4亿元回购夯实股价安全垫\n公司已连续实施两轮股份回购，累计回购金额超过4亿元，是近期托底股价的重要支撑力量。大额回购动作向市场传递了管理层对公司长期内在价值的认可，在震荡市中降低了股价大幅下行的弹性。\n当前公司发行的可转换公司债券仍处于转股期，后续相关安排公司将以公告形式正式披露，市场预期后续股本结构优化动作有望进一步配合市值管理目标推进。\n\n## 三、行业政策催化：资本市场改革预期带动非银板块情绪\n2026年6月下旬，资本市场投资端改革相关政策预期持续升温，中信证券等头部券商研报指出，《资本市场投资端改革行动方案》或将出台，同时券商风控指标优化、行业并购重组支持政策同步推进，证券行业迎来历史性发展机遇。国投资本作为涵盖证券、信托、基金等多牌照的国有金融控股平台，直接受益于非银金融板块的政策红利扩散。\n市场预期中长期资金入市比例提升、交易端活跃度改善，将直接带动公司旗下经纪、资管、信托等多线业务的盈利弹性释放，成为当前资金交易的重要预期主线。\n\n## 四、资金面格局：存量博弈下主力资金短期净流出\n截至2026年7月14日收盘，国投资本全天成交额1.98亿元，换手率0.48%，当日主力资金净流出1701.84万元，游资资金净流入350.38万元，散户资金净流入1351.46万元。当前整体交投活跃度处于偏低水平，存量博弈特征明显，尚未出现增量资金大规模进场推动股价趋势性上涨的信号。\n近期股价窄幅波动区间未突破前期震荡平台，资金分歧主要来源于短期业绩兑现节奏与长期估值修复空间的定价差异。\n\n## 风险提示\n1.  旗下国投瑞银基金此前推出的国投白银LOF投资者补偿方案，预计对2026年度归母净利润产生一定负面影响，影响上限约1.35亿元，后续实际计提金额仍存在不确定性。\n2.  证券行业政策落地节奏不及预期，若市场交易量持续维持低位，将直接拖累公司旗下证券、资管板块的盈利表现。\n3.  当前公司股价震荡格局未有效打破，主力资金连续短期净流出，后续若缺乏增量资金接力，估值修复进程可能慢于市场预期。\n4.  可转债转股后续进展存在不确定性，可能对二级市场股份供需结构带来阶段性扰动。\n\n信息仅供参考，不构成投资建议。",
            //     "model": "doubaoseed2.0-lite",
            //     "report_date": "2026-07-15",
            //     "update_at": "2026-07-15 14:31:08"
            //     },

            //     ai_report:{
            //     "content": "# 浦发银行（600000）近期震荡分化 6月创60日新低（截至2026年7月15日）\n浦发银行近期整体呈现**震荡分化、多空力量相对均衡**的走势，6月29日盘中创下8.63元的60日新低后股价逐步修复，截至7月中旬股价围绕9元一线波动。基本面端一季度营收、净利润小幅双增，支撑估值底；资金面则呈现主力资金阶段性流出、融资资金小幅加仓的分歧格局，当前交易主线围绕银行板块资产质量修复与高股息分红展开。\n\n## 一、走势复盘：60日新低后窄幅震荡，多空博弈收敛\n- 6月29日盘中股价下探8.63元，创下近60个交易日新低，当日跌幅1.48%，短期抛压集中释放。\n- 新低之后股价未继续大幅下挫，逐步回升至9元附近震荡，近20个交易日主力资金成本约8.97元，当前价格贴近机构持仓成本线。\n- 技术面指标暂无明确趋势性信号，短期市场关注意愿保持中性，未出现极端放量或缩量的异动特征。\n\n## 二、基本面支撑：一季报营收净利双增，资产质量持续向好\n- 据2026年一季报披露，报告期内集团实现营业收入465.73亿元，同比增长1.42%；归母净利润178.61亿元，同比增长1.49%，实现稳健开局。\n- 资产负债结构持续优化，报告期末存款总额较上年末增长3.52%，活期存款占比较上年末提升1.97个百分点，利息净收入同比增长12.43%，负债端成本管控成效显现。\n- 资产质量保持“双降”态势，不良贷款率1.23%，较上年末下降0.03个百分点；拨备覆盖率204.79%，较上年末上升4.07个百分点，风险缓冲垫进一步增厚。\n\n## 三、资金面分歧：主力阶段性流出，融资资金逆势加仓\n- 据证券之星披露，6月29日前10个交易日内，主力资金累计净流出4757.25万元，短期机构资金呈现阶段性兑现动作，是股价创下60日新低的直接推手之一。\n- 同期融资余额累计增加6513.27万元，融资资金呈现逆势布局态势；截至7月13日，公司融资融券差额为37.76亿元，占流通盘比例1.23%，较前一交易日略有上升。\n- 据东方财富网数据，当前机构参与度为39.77%，属于中度控盘区间，主力资金尚未出现大幅集中流入或流出的极端信号，资金整体处于观望状态。\n\n## 四、近期事件催化：2025年度权益分派落地，高股息属性强化\n- 据7月10日公司发布的2025年年度权益分派实施公告，年度分红方案进入落地执行阶段，持续兑现银行板块高股息属性，对长期配置资金形成一定吸引力。\n- 公司科技金融贷款余额保持1万亿元以上，绿色信贷余额达7383.57亿元，普惠两增贷款规模5367.28亿元，持续契合国家政策导向，市场对其长期业务结构优化形成稳定预期。\n\n## 风险提示\n银行板块整体息差仍面临行业性收窄压力，可能对后续利息净收入增速形成约束。宏观经济复苏节奏若不及预期，可能导致部分区域信贷资产质量出现波动。近期主力资金未呈现明确持续流入态势，股价短期向上弹性或相对有限。行业板块整体估值修复行情若出现回调，个股或随板块同步波动。\n\n信息仅供参考，不构成投资建议。",
            //     "model": "doubaoseed2.0-lite",
            //     "report_date": "2026-07-15",
            //     "update_at": "2026-07-15 14:05:32"
            //     },

            //     ai_report:{
            //     "content": "# 万东医疗（600055）震荡反弹 回购与板块共振下的行情解读（截至2026年7月15日）\n万东医疗近期呈现**板块贝塔行情带动下的震荡反弹走势**，7月初受股份回购落地催化出现阶段性跟涨，7月中旬随半年度业绩预告披露进入多空博弈阶段。当前核心交易主线围绕回购价值支撑、影像设备行业政策修复预期与海外业务高增三条逻辑展开，同时业绩短期承压带来一定估值压制。\n\n## 一、直接催化：近6000万元股份回购落地，传递价值认可信号（行情支撑底）\n据公司2026年7月1日披露的回购实施结果公告，截至6月30日公司已累计完成回购金额5998.98万元，接近此前计划回购金额上限。\n- 本次回购股份用途为后续股权激励或员工持股计划，管理层以真金白银向市场传递对公司长期价值的认可，对短期股价形成直接托底支撑。\n- 从市场反馈来看，7月1日当日股价随医疗器械设备板块同步上行，成为行情启动的直接触发因素之一，资金对回购落地的正向解读短期推升了个股交易热度。\n\n## 二、基本面主线：海外业务高增对冲国内压力，新管线拓展打开空间（长期逻辑）\n据公司披露的2025年年报及最新业务动态，公司全球化布局步伐持续加快，产品矩阵不断向细分场景延伸。\n- 2025年公司海外营收达3.6亿元，同比增长54.38%，欧洲市场DR设备累计装机量突破700台，其中意大利单国装机量近300台，产品已进入全球110多个国家和地区，海外业务成为核心增长极。\n- 公司持续拓展非医疗影像赛道，推出动物专用“液金”CT等产品，2026年3月与动物医疗影像设备头部企业达成深度战略合作，由后者出任动物专用螺旋CT全国总代，市场预期该细分赛道将逐步贡献新业绩增量。\n\n## 三、板块共振：医疗设备集采政策边际优化，行业贝塔行情带动跟涨（行情放大器）\n近期国内医疗设备领域政策预期持续修复，成为板块整体上行的核心背景。\n- 2025年公司在公立医院影像设备集采中中标量实现翻两番，市场份额提升10.23个百分点，国内公立市场基本盘进一步巩固，行业政策层面的边际改善缓解了市场对集采过度压价的担忧。\n- 医疗设备板块整体交易情绪回暖，带动万东医疗等核心影像设备标的同步反弹，个股本轮上涨更多属于板块β行情下的被动跟涨，并非独立的基本面反转行情。\n\n## 四、资金面特征：成交温和放大，融资与板块资金同步流入（短期情绪指标）\n本轮反弹过程中，万东医疗成交额较此前震荡阶段出现明显放量，市场交投活跃度显著提升。\n- 医疗器械板块整体资金净流入规模居前，个股获部分偏稳健型配置资金关注，资金交易主线集中在“国产替代+出口高增”赛道。\n- 目前龙虎榜暂无机构大额买卖异动记录，融资余额随股价反弹小幅回升，整体资金行为以波段配置为主，尚未出现趋势性主力资金大幅介入信号。\n\n## 风险提示\n1. 据2026年7月11日公司披露的半年度业绩预告，上半年归母净利润预亏超8250万元，大型设备收入确认周期长、低价集采订单集中入账拉低毛利率，业绩短期承压明显。\n2. 2025年民营医院业务收入同比下滑55%，医保支付方式改革下民营医疗资本开支收缩的影响仍未完全消除。\n3. 公司收到上交所2025年年报及2026年一季报信息披露监管问询函，涉及经销模式收入确认、库存管理等内控相关问题，后续整改落地进度仍需跟踪。\n4. 无液氦MRI等核心新产品的FDA审批进展尚未有明确时间表，市场预期存在兑现不及预期的可能。\n\n信息仅供参考，不构成投资建议。",
            //     "model": "doubaoseed2.0-lite",
            //     "report_date": "2026-07-15",
            //     "update_at": "2026-07-15 14:27:35"
            //     },
            // }
            // this.purchased = 1;
            // console.log('validateMarkdown ???')
            // if(this.validateMarkdown(data2.ai_report.content)){
            //     console.log('validateMarkdown')
            // }
            // let markdown = data2.ai_report.content;
            // console.log(markdown)
            // let parsed = this.parseMarkdown(markdown);
            // console.log('parsed',parsed)
            // this.sections = parsed.sections;
            // this.riskSection = parsed.riskSection;
            // this.overviewContent = parsed.overviewContent;
        },
        methods:{
            toggleRisk() {
                this.isRiskOpen = !this.isRiskOpen
            },
            parseMarkdown(markdown) {
                const lines = markdown.split('\n')
                
                let overviewContent = ''
                let sections = []
                let riskItems = []
                let disclaimer = ''
                
                let currentSection = null
                let currentItems = []
                let currentIntro = []
                let isCollectingItems = false
                let isRiskSection = false
                let isOverview = false

                // 有效章节数字映射
                const validSectionNumbers = ['一', '二', '三', '四', '五', '六']
                const numberToIndex = { '一': 0, '二': 1, '三': 2, '四': 3, '五': 4, '六': 5 }

                const iconMap = {
                    '一': 'https://cdncos.aigupiao.com/assets/pc/img/2023/figma-assets/icon-core.svg',
                    '二': 'https://cdncos.aigupiao.com/assets/pc/img/2023/figma-assets/icon-basic.svg',
                    '三': 'https://cdncos.aigupiao.com/assets/pc/img/2023/figma-assets/icon-amoled.svg',
                    '四': 'https://cdncos.aigupiao.com/assets/pc/img/2023/figma-assets/icon-car.svg',
                    '五': 'https://cdncos.aigupiao.com/assets/pc/img/2023/figma-assets/icon-fund.svg',
                    '六': 'https://cdncos.aigupiao.com/assets/pc/img/2023/figma-assets/icon-plus.svg'
                }

                const processText = (text) => {
                    let content = text
                    content = content.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
                    content = content.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank">$1</a>')
                    return content
                }

                // 判断章节是否在有效范围内（一 到 六）
                const isValidSection = (num) => {
                    return validSectionNumbers.includes(num)
                }

                for (let i = 0; i < lines.length; i++) {
                    const line = lines[i].trim()
                    if (!line) continue

                    // ===== 检测风险提示标题 =====
                    const riskMatch = line.match(/^#{2,3}\s+(风险提示.*)$/)
                    if (riskMatch) {
                    if (currentSection && (currentItems.length > 0 || currentIntro.length > 0)) {
                        sections.push({
                        title: currentSection,
                        intro: [...currentIntro],
                        items: [...currentItems],
                        icon: iconMap[currentSection.charAt(0)] || 'https://cdncos.aigupiao.com/assets/pc/img/2023/figma-assets/icon-core.svg'
                        })
                    }
                    currentSection = null
                    currentItems = []
                    currentIntro = []
                    isCollectingItems = false
                    isRiskSection = true
                    isOverview = false
                    continue
                    }

                    // ===== 检测章节标题（只识别 一 到 六） =====
                    const sectionMatch = line.match(/^##\s+([一二三四五六七八九十]+)、(.+)$/)
                    if (sectionMatch) {
                    const num = sectionMatch[1]
                    // 只处理 一 到 六 的章节，超出部分忽略
                    if (!isValidSection(num)) {
                        // 如果当前正在收集内容，先保存之前的
                        if (currentSection && (currentItems.length > 0 || currentIntro.length > 0)) {
                        sections.push({
                            title: currentSection,
                            intro: [...currentIntro],
                            items: [...currentItems],
                            icon: iconMap[currentSection.charAt(0)] || 'https://cdncos.aigupiao.com/assets/pc/img/2023/figma-assets/icon-core.svg'
                        })
                        }
                        // 清空状态，停止收集（超出范围的章节不展示）
                        currentSection = null
                        currentItems = []
                        currentIntro = []
                        isCollectingItems = false
                        isRiskSection = false
                        isOverview = false
                        continue
                    }

                    // 保存上一个章节
                    if (currentSection && (currentItems.length > 0 || currentIntro.length > 0)) {
                        sections.push({
                        title: currentSection,
                        intro: [...currentIntro],
                        items: [...currentItems],
                        icon: iconMap[currentSection.charAt(0)] || 'https://cdncos.aigupiao.com/assets/pc/img/2023/figma-assets/icon-core.svg'
                        })
                    }
                    currentSection = `${sectionMatch[1]}、${sectionMatch[2]}`
                    currentItems = []
                    currentIntro = []
                    isCollectingItems = true
                    isRiskSection = false
                    isOverview = false
                    continue
                    }

                    // ===== 检测免责声明 =====
                    if (line.includes('信息仅供参考')) {
                    disclaimer = line
                    continue
                    }

                    // ===== 检测概述 =====
                    if (!isOverview && !isRiskSection && !currentSection && line && !line.match(/^#/)) {
                    overviewContent = processText(line)
                    isOverview = true
                    continue
                    }

                    // ===== 处理风险部分 =====
                    if (isRiskSection) {
                    const bulletMatch = line.match(/^-\s+(.+)$/)
                    if (bulletMatch) {
                        riskItems.push(processText(bulletMatch[1]))
                        continue
                    }
                    const numMatch = line.match(/^(\d+)\.\s+(.+)$/)
                    if (numMatch) {
                        riskItems.push(processText(numMatch[2]))
                        continue
                    }
                    if (line && !line.match(/^#/)) {
                        if (riskItems.length > 0) {
                        const last = riskItems[riskItems.length - 1]
                        if (!/[。；;！?！]$/.test(last)) {
                            riskItems[riskItems.length - 1] = last + ' ' + processText(line)
                            continue
                        }
                        }
                        riskItems.push(processText(line))
                    }
                    continue
                    }

                    // ===== 处理章节内容 =====
                    if (isCollectingItems && currentSection) {
                    const bulletMatch = line.match(/^-\s+(.+)$/)
                    if (bulletMatch) {
                        currentItems.push(processText(bulletMatch[1]))
                        continue
                    }
                    const numMatch = line.match(/^(\d+)\.\s+(.+)$/)
                    if (numMatch) {
                        currentItems.push(processText(numMatch[2]))
                        continue
                    }
                    // ===== 纯文本段落：加入 intro 数组 =====
                    if (line && !line.match(/^#/) && !line.match(/^-\s+/) && !line.match(/^\d+\.\s+/)) {
                        const processed = processText(line)
                        if (currentItems.length === 0) {
                        currentIntro.push(processed)
                        } else {
                        const last = currentItems[currentItems.length - 1]
                        if (!/[。；;！?！]$/.test(last)) {
                            currentItems[currentItems.length - 1] = last + ' ' + processed
                        }
                        }
                    }
                    }
                }

                // ===== 保存最后一个章节 =====
                if (currentSection && (currentItems.length > 0 || currentIntro.length > 0)) {
                    sections.push({
                    title: currentSection,
                    intro: [...currentIntro],
                    items: [...currentItems],
                    icon: iconMap[currentSection.charAt(0)] || 'https://cdncos.aigupiao.com/assets/pc/img/2023/figma-assets/icon-core.svg'
                    })
                }

                return {
                    overviewContent,
                    sections,
                    riskSection: riskItems.length > 0 ? { title: '风险提示', items: riskItems } : null,
                    disclaimer
                }
            },
            validateMarkdown(markdown) {
                // 1. 必须有一级标题
                const hasTitle = /^#\s+.+/m.test(markdown)
                
                // 2. 必须有至少一个章节标题（## 一、 到 ## 六、）
                const hasSection = /^##\s+[一二三四五六]+、.+$/m.test(markdown)
                
                // 3. 必须有风险提示
                const hasRisk = /^#{2,3}\s+风险提示/m.test(markdown)

                return hasTitle && hasSection && hasRisk;
            },
            expand(){
                this.longhu_expand = !this.longhu_expand;
            },
            parseF(val){
                val = (parseFloat(val) * 100).toFixed(2);
                if(val > 0) val = '+'+val;
                return val;
            },
            async stockDetail(opt){
                let res = await Api.stockDetail(opt);
                console.log(res)
                if(res.code == 1001) {
                    //暂无此诊股
                    this.purchased = 2;
                }
                else if(res.code == 1002 || res.code == 1003 || ( res.code == 1004 && (this.is_from_agq || this.is_from_kd || this.is_from_zf) ) ){
                    //购买的产品已过期，请重新购买 or请先购买产品
                    this.purchased = 0;
                }
                else if(res.code == 0){
                    this.purchased = 1;

                    let data = res.data;
                    let synthesis = data.synthesis;
                    let short = data.short;
                    let institutions = data.institutions;
                    this.insGradeResult = institutions.insGradeResult;
                    this.insHoldRatio = institutions.insHoldRatio;
                    this.insTargetPrice = institutions.insTargetPrice;
                    this.overview = synthesis.overview;
                    this.quality = synthesis.quality;
                    //this.risk = synthesis.risk;  ---没用上
                    this.strategy = synthesis.strategy;
                    this.update_time = synthesis.update_time;
                    this.dragonTiger = short.dragonTiger;
                    this.finSecGraph = short.finSecGraph;
                    this.moneyGraph = short.moneyGraph;
                    this.techAspect = short.techAspect;

                    if(data.ai_report && data.ai_report.content && this.validateMarkdown(data.ai_report.content)){
                        this.has_ai_report = true;
                        let markdown = data.ai_report.content;
                        let parsed = this.parseMarkdown(markdown);
                        console.log('parsed-validateMarkdown',parsed)
                        this.sections = parsed.sections;
                        this.riskSection = parsed.riskSection;
                        this.overviewContent = parsed.overviewContent;
                    }
                    else{
                        this.has_ai_report = false;
                    }


                    console.log('znzg',data.znzg)
                    if(data.znzg.message == "success"){
                        this.znzg_in = true;
                        let _data = data.znzg.data;
                        this.changeAreaTheme = _data.changeAreaTheme;
                        this.industryInfo = _data.industryInfo;
                        this.industryComment = _data.industryComment;
                        this.themeComment = _data.themeComment;
                    }



                    if(this.insGradeResult.comment.indexOf("以增持为主")>-1){
                        this.price_left = 75;
                    }else if(this.insGradeResult.comment.indexOf("以买入为主")>-1){
                        this.price_left = 85;
                    }else if(this.insGradeResult.comment.indexOf("以卖出为主")>-1){
                        this.price_left = 15;
                    }else if(this.insGradeResult.comment.indexOf("以减持为主")>-1){
                        this.price_left = 30;
                    } else if(this.insGradeResult.comment.indexOf("以中性为主")>-1){
                        this.price_left = 48;
                    }

                    this.mainCapital1 = this.moneyGraph.mainCapital;

                    this.finance_comment = data.finance_comment;
                    if(this.finance_comment.highlight) this.highlight = this.finance_comment.highlight.split('\n');
                    if(this.finance_comment.risk) this.risk = this.finance_comment.risk.split('\n');
                    if(!this.insTargetPrice.pct){
                        this.$nextTick(()=> {
                            console.log(this.$refs.chart)
                            let chart_h = this.$refs.chart.offsetHeight;
                            this.avg_top = chart_h + 'px';
                            this.cur_top = 0;
                        })
                    }
                    else {
                        this.$nextTick(()=>{
                            console.log(this.$refs.chart)
                            let chart_h = this.$refs.chart.offsetHeight;
                            let chartsqure_h = this.$refs.chartsqure.offsetHeight;
                            let price = this.insTargetPrice;
                            let range,real_h,avg_h;
                            if(price.ceil == "最高目标价"){
                                if(price.cur - price.avg > 0){
                                    range = price.max - price.min;
                                    real_h = (price.max - price.cur) / range * chart_h;
                                    this.squre_height = real_h -1 +'px';
                                    this.squre_top = 0 +'px';
                                    this.cur_top = real_h  + 'px';
                                    avg_h = (price.max - price.avg) / range * chart_h;
                                    if(avg_h - real_h < chartsqure_h){
                                        avg_h = real_h + chartsqure_h;
                                    }
                                    this.avg_top = avg_h +'px';
                                }

                            }
                            else if(price.ceil == "平均目标价"){

                                if(price.min - price.cur > 0){
                                    range = price.max - price.cur;
                                    real_h = (price.avg - price.cur) / range * chart_h;
                                    avg_h = (price.max - price.avg) / range * chart_h;
                                    let min_h = (price.min - price.cur) / range * chart_h;
                                    if(real_h < chartsqure_h){
                                        real_h = chartsqure_h;
                                    }
                                    this.avg_top = avg_h +'px';
                                    this.squre_height = real_h -1  +'px';
                                    this.squre_top = avg_h + 1 +'px';
                                    this.cur_top = chart_h + 'px';
                                    this.min_bottom = min_h + 'px';
                                }
                                else{
                                    console.log(0)
                                    range = price.max - price.min;
                                    real_h = (price.avg - price.cur) / range * chart_h;
                                    avg_h = (price.max - price.avg) / range * chart_h;
                                    if(real_h < chartsqure_h){
                                        real_h = chartsqure_h;
                                    }
                                    this.avg_top = avg_h +'px';
                                    this.squre_height = real_h -1 +'px';
                                    this.squre_top = avg_h + 1 +'px';
                                    this.cur_top = real_h + avg_h + 'px';
                                }
                            }


                        })

                    }
                }
                else {
                    //其他报错 也显示无诊股
                    this.purchased = 2;
                }

            },
            funToApp(funName, opt) {
                var u = navigator.userAgent,
                    app = navigator.appVersion;
                var data = null;
                var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
                var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
                if (isAndroid) {
                    if (window.android) {
                        console.log("安卓APP---" + funName, ...opt);
                        data = window.android[funName] && window.android[funName](...opt);
                    }
                } else if (isiOS) {
                    console.log("IOS---" + funName, [...opt]);
                    // data = window[funName] && window[funName](...opt);
                    data = window.webkit && window.webkit.messageHandlers[funName].postMessage([...opt])
                }
                return data;
            }
            

        },
        computed: {
        riskListStyle() {
            return this.isRiskOpen 
                ? { height: 'auto', opacity: 1 } 
                : { height: 0, opacity: 0, overflow: 'hidden' }
            }
    },
    }
</script>

<style lang="scss">
/* 不加 scoped，让变量真正全局生效 */
:root {
  color-scheme: light;
  --page-bg: #f7f5f6;
  --card-bg: #ffffff;
  --card-shadow: 0 2px 6px rgba(90, 30, 30, 0.06);
  --text: #333333;
  --muted: #9aa3b2;
  --link: #1d88d0;
  --topic: #1d88d0;
  --icon-bg: #fdecec;
  --icon: #ff8a8a;
  --highlight: #fff3a8;
  --risk-bg: #fffaf4;
  --risk-icon-bg: #feedc5;
  --risk-text: #8a4b0a;
  --risk-line: rgba(235, 162, 81, 0.18);
}
</style>
<style lang="scss" scoped>
    * {
      box-sizing: border-box;
    }

    html {
      min-height: 100%;
      background: #eeeeee;
    }

    body {
      margin: 0;
      min-height: 100vh;
      display: flex;
      justify-content: center;
      color: var(--text);
      background: #eeeeee;
      font-family: "Noto Sans SC", -apple-system, BlinkMacSystemFont, "PingFang SC", "Microsoft YaHei", "Segoe UI", sans-serif;
      letter-spacing: 0;
    }


</style>
<style lang="scss" >

.phone_znzg::before {
    content: "";
    position: absolute;
    top: 0;
    left: 50%;
    z-index: 0;
    width: min(100vw, 375px);
    height: 260px;
    transform: translateX(-50%);
    pointer-events: none;
    background: linear-gradient(180deg, #fde5e5 0, rgba(253, 229, 229, 0) 240px);
}


.phone_znzg {
    width: min(100vw, 375px);
    position: relative;
    isolation: isolate;
    background: var(--page-bg);
    padding: 12px 12px;
}
@media (max-width: 360px) {
    .phone_znzg {
    padding-left: 10px;
    padding-right: 10px;
    }
}

.phone_znzg{
    .section-stack {
      position: relative;
      z-index: 1;
      display: grid;
      gap: 8px;
    }

    .stock-tools {
      display: grid;
      gap: 8px;
      padding: 10px;
      border-radius: 12px;
      background: rgba(255, 255, 255, 0.84);
      box-shadow: var(--card-shadow);
    }

    .search-box {
      height: 40px;
      display: grid;
      grid-template-columns: 18px minmax(0, 1fr);
      align-items: center;
      gap: 8px;
      padding: 0 10px;
      border: 1px solid rgba(235, 235, 235, 0.92);
      border-radius: 10px;
      background: #ffffff;
      color: var(--muted);
      font-size: 14px;
    }

    .search-box input {
      width: 100%;
      border: 0;
      outline: 0;
      background: transparent;
      color: var(--text);
      font: inherit;
      min-width: 0;
    }

    .search-box input::placeholder {
      color: #a7afbb;
    }

    .switch-row {
      display: grid;
      grid-template-columns: 36px minmax(0, 1fr) 36px;
      gap: 8px;
      align-items: center;
    }

    .switch-button {
      width: 36px;
      height: 34px;
      border: 0;
      border-radius: 9px;
      background: #ffffff;
      color: #7d8794;
      font-size: 24px;
      line-height: 1;
      box-shadow: inset 0 0 0 1px rgba(235, 235, 235, 0.94);
    }

    .stock-count {
      min-width: 0;
      color: #727b88;
      font-size: 12px;
      text-align: center;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .stock-strip {
      display: grid;
      grid-auto-flow: column;
      grid-auto-columns: minmax(106px, 128px);
      gap: 8px;
      overflow-x: auto;
      padding-bottom: 2px;
      scrollbar-width: none;
    }

    .stock-strip::-webkit-scrollbar {
      display: none;
    }

    .stock-option {
      min-height: 54px;
      border: 0;
      border-radius: 10px;
      background: #ffffff;
      box-shadow: inset 0 0 0 1px rgba(235, 235, 235, 0.94);
      padding: 8px 10px;
      color: var(--text);
      text-align: left;
    }

    .stock-option.active {
      background: #fff4f4;
      box-shadow: inset 0 0 0 1px rgba(255, 132, 132, 0.42);
    }

    .stock-option strong {
      display: block;
      font-size: 14px;
      line-height: 1.25;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .stock-option span {
      display: block;
      margin-top: 4px;
      color: var(--muted);
      font-size: 11px;
      line-height: 1.2;
      text-transform: uppercase;
    }

    .empty {
      padding: 18px 12px;
      color: var(--muted);
      text-align: center;
      font-size: 13px;
    }

    .overview,
    .logic-card,
    .risk-card {
      width: 100%;
      border-radius: 12px;
      box-shadow: var(--card-shadow);
    }

    .overview {
      display: grid;
      gap: 8px;
      padding: 12px;
      background: var(--card-bg);
    }

    .overview h2 {
      margin: 0;
      font-size: 15px;
      line-height: 1.6;
      font-weight: 800;
    }

    .overview p {
      margin: 0;
      font-size: 14px;
      line-height: 1.6;
      font-weight: 400;
      word-break: break-word;
    }

    .overview a,
    .blue {
      color: var(--link);
      text-decoration: none;
    }

    .overview strong {
      color: var(--text);
      font-weight: 800;
    }

    .topic {
      color: var(--text);
      font-weight: 700;
    }

    .logic-card,
    .risk-card {
      overflow: hidden;
      background: var(--card-bg);
    }

    details {
      display: block;
    }

    summary {
      min-height: 64px;
      display: grid;
      grid-template-columns: 30px minmax(0, 1fr) 22px;
      gap: 12px;
      align-items: center;
      padding: 12px;
      list-style: none;
      cursor: pointer;
      -webkit-tap-highlight-color: transparent;
    }

    summary::-webkit-details-marker {
      display: none;
    }

    .icon {
      width: 30px;
      height: 30px;
      display: grid;
      place-items: center;
      align-self: center;
      border-radius: 9px;
      background: var(--icon-bg);
      color: var(--icon);
    }

    .icon img {
      width: 20px;
      height: 20px;
      display: block;
    }

    .summary-title {
      margin: 0;
      min-width: 0;
      color: var(--text);
      font-size: 15px;
      line-height: 1.6;
      font-weight: 800;
      word-break: break-word;
    }

    .chevron {
      width: 9px;
      height: 9px;
      justify-self: center;
      border-right: 2px solid var(--muted);
      border-bottom: 2px solid var(--muted);
      transform: rotate(45deg);
      transition: transform 220ms ease;
    }

    details[open] .chevron {
      transform: rotate(225deg);
    }

    details.closing .chevron {
      transform: rotate(45deg);
    }

    .logic-body {
      padding: 0 12px 12px;
      font-size: 14px;
      line-height: 1.6;
      color: var(--text);
      word-break: break-word;
      overflow: hidden;
      transition: height 240ms ease, opacity 200ms ease;
      will-change: height, opacity;
    }

    .logic-body p {
      margin: 0 0 8px;
    }

    .logic-body p:last-child {
      margin-bottom: 0;
    }

    .numbered-item,
    .bullet-item {
      display: grid;
      gap: 6px;
      align-items: start;
    }

    .numbered-item {
      grid-template-columns: auto minmax(0, 1fr);
    }

    .bullet-item {
      grid-template-columns: 10px minmax(0, 1fr);
      padding-left: 16px;
    }

    .item-marker {
      font-weight: 400;
      white-space: nowrap;
    }

    .bullet-dot {
      width: 5px;
      height: 5px;
      margin-top: 11px;
      border-radius: 50%;
      background: var(--text);
    }

    .item-copy {
      min-width: 0;
    }

    .logic-body ul {
      display: grid;
      gap: 8px;
      margin: 0 0 8px;
      padding-left: 18px;
    }

    .logic-body li {
      margin: 0;
    }

    .logic-body strong {
      color: var(--text);
      font-weight: 800;
    }

    .overview .text-link,
    .logic-body .text-link,
    .risk-list .text-link {
      color: var(--link);
      text-decoration: none;
      font-weight: inherit;
    }

    .key {
      font-weight: 800;
    }

    .risk-card {
      display: grid;
      gap: 12px;
      padding: 12px;
      background:
        linear-gradient(90deg, var(--risk-bg), var(--risk-bg)),
        linear-gradient(90deg, #fff3e0, #fff7ed),
        #ffffff;
    }

    .risk-head {
      width: 100%;
      border: 0;
      display: grid;
      grid-template-columns: 30px minmax(0, 1fr) 22px;
      gap: 12px;
      align-items: center;
      padding: 0;
      background: transparent;
      color: inherit;
      text-align: left;
      cursor: pointer;
      font: inherit;
      -webkit-tap-highlight-color: transparent;
    }

    .risk-head .icon {
      background: var(--risk-icon-bg);
      color: #ffb84c;
    }

    .risk-head h3 {
      margin: 0;
      font-size: 15px;
      line-height: 1.6;
      font-weight: 800;
    }

    .risk-card.open .risk-head .chevron {
      transform: rotate(225deg);
    }

    .risk-list {
      display: grid;
      gap: 8px;
      overflow: hidden;
      transition: height 240ms ease, opacity 200ms ease;
      will-change: height, opacity;
    }

    @media (prefers-reduced-motion: reduce) {
      .chevron,
      .logic-body,
      .risk-list {
        transition: none;
      }
    }

    .risk-item {
      margin: 0;
      color: var(--risk-text);
      font-size: 13px;
      line-height: 1.5;
      word-break: break-word;
    }

    .risk-divider {
      height: 1px;
      background: repeating-linear-gradient(90deg, var(--risk-line) 0 3px, transparent 3px 6px);
    }

    @media (max-width: 360px) {

      summary,
      .risk-head {
        grid-template-columns: 28px minmax(0, 1fr) 20px;
        gap: 10px;
      }

      .icon {
        width: 28px;
        height: 28px;
      }

      .stock-strip {
        grid-auto-columns: minmax(100px, 120px);
      }
    }

}
    
</style>
<style lang="scss" scope>

    @import "~@/assets/sass/global.scss";

    /* 未购买时*/
    .not_purchased{
        width: 100vw;
        min-height: 100vh;
        position: absolute;
        left: 0;
        top: 0;
        background: url(https://cdncos.aigupiao.com/assets/pc/img/2023/znzg_bg.png) 0 0;
        background-size: 100%;
        transform-origin: center center;
        .not_purchased_box{
            text-align: center;
            width: rem(673px);
            min-height: rem(455px);
            background: rgba(255, 255, 255, 0.96);
            box-shadow: 0px rem(2px) rem(14px) 0px rgba(181, 181, 181, 0.5);
            border-radius: rem(20px);
            position: absolute;
            bottom: rem(92px);
            left: 50%;
            transform: translateX(-50%);
            z-index: 20;
            .not_name{
                height: rem(42px);
                font-size: rem(30px);
                font-weight: 400;
                color: #000000;
                line-height: rem(48px);
                padding-top: rem(25px);
            }
            .not_situation{
                height: rem(30px); //42原是
                font-size: rem(26px);
                font-weight: 400;
                color: #FE484A;
                line-height: rem(30px);
            }
            .not_trait{
                display: flex;
                justify-content: space-around;
                margin: rem(24px) 0 rem(44px);
                align-items: flex-end;
                .not_trait_img{
                    margin-bottom: rem(22px);
                    .img_one{
                        width: rem(44px);
                    }
                    .img_two{
                        width: rem(55px);
                    }
                    .img_three{
                        width: rem(50px);
                    }
                }
            }
            .not_trait_word{
                height: rem(28px);
                font-size: rem(20px);
                font-weight: 400;
                color: #333333;
                line-height: rem(29px);
            }
            .not_btn{
                padding: 0 rem(47px);
                height: rem(92px);
                background: #FE484A;
                box-shadow: 0px rem(4px) rem(11px) 0px rgba(231, 69, 69, 0.5);
                border-radius: rem(53px);
                text-align: center;
                font-size: rem(30px);
                font-weight: 400;
                color: #FFFFFF;
                line-height: rem(92px);
                margin: 0 auto;
                display: inline-block;
            }
            >p{
                margin-top: rem(20px);
                height: rem(30px);
                font-size: rem(22px);
                font-weight: 400;
                color: #636363;
                line-height: rem(30px);
                text-align: center;
            }
            .agq{

                font-size: rem(26px);
                font-weight: 400;
                color: #636363;
                line-height: rem(37px);
                padding-bottom: rem(30px);
                >a{
                    padding-left: rem(35px);
                    color: #1D88D0;
                    background: url(../../assets/images/znzg/agq.png) 0 center no-repeat;
                    background-size: rem(28px);
                }
            }
        }
    }



    /*购买之后*/
    .data_update{
        padding-left: rem(28px);
        // width: 100vw;
        height: rem(53px);
        background: #FFF7F1;
        font-size: rem(24px);
        font-weight: 400;
        color: #F68532;
        line-height: rem(53px);
    }
    .data_box{
        border-top: rem(12px) solid #F5F6F7;
        padding: 0 rem(28px);
        background-color: #ffffff;
        .goodness{
            padding-bottom: rem(25px);
            .goodness_title{
                height: rem(42px);
                img{
                    width: rem(30px);
                    margin-right: rem(6px);
                    position: relative;
                    top: rem(6px);
                }
                span{
                    height: rem(42px);
                    font-size: rem(30px);
                    font-weight: 500;
                    color: #FE484A;
                    line-height: rem(42px);
                }
                .goodness_title_blue{
                    color: #3E89FE;
                }
            }
            .goodness_content{
                li{
                    font-size: rem(28px);
                    font-weight: 400;
                    color: #636363;
                    line-height: rem(40px);
                    list-style: none;
                    margin-left: rem(36px);
                    position: relative;
                }
                .goodness_point{
                    width: rem(10px);
                    height: rem(10px);
                    background-color: #FE484A;
                    border-radius: 50%;
                    position: absolute;
                    left: rem(-26px);
                    top: rem(16px);
                }
                .goodness_content_blue{
                    background-color: #3E89FE;
                }
            }
        }


        .target_price{
            padding-bottom: rem(50px);
            .target_price_content{
                font-size: rem(28px);
                font-weight: 400;
                color: #636363;
                line-height: rem(40px);
                margin-bottom: rem(50px);
                .span_tag{
                    color: #FE484A;
                }

            }
            .target_price_content_none{
                margin-bottom: 0;
            }
            .target_price_chart{
                height: rem(300px);
                margin: rem(50px) rem(100px) rem(20px) rem(120px);
                position: relative;
                .target_price_chart_box{
                    width: 100%;
                    height: rem(2px);
                    position: absolute;
                    left: 0;
                    font-size: rem(22px);
                    > div:nth-child(1){
                        position: absolute;
                        left: rem(-120px);
                        //top: rem(-15px);
                        color: #939393;
                        z-index: 1;
                    }
                    > div:nth-child(2){
                        position: absolute;
                        right: rem(-100px);
                        //top: rem(-15px);
                        color: #333333;
                    }
                    > div.target_font_blue{
                        color: #3E89FE;
                    }
                    > div.target_font_red{
                        color: #FE484A;
                    }
                }
                .target_price_chart_box_red{
                    background: #FE484A;
                }
                .target_price_chart_box_blue{
                    background: #3E89FE;

                }

                .target_price_chart_squre{
                    position: absolute;
                    left: 0;
                    min-height: rem(32px);
                    background: #f6f9ff;
                    width: 100%;
                    .target_price_chart_squre_text{
                        font-size: rem(24px);
                        color: #f2666d;
                        height: 100%;
                        display: flex;
                        align-items: center;
                        position: absolute;
                        left: 55%;
                    }
                    .target_price_chart_squre_tag{
                        position: absolute;
                        top: 0;
                        left: 50%;
                        height: 100%;
                        width: rem(2px);
                        background: #5e94fa;
                        > div:nth-child(1){
                            position: absolute;
                            width: rem(2px);
                            height: rem(24px);
                            top: 0;
                            left: rem(-4px);
                            -ms-transform: rotate(20deg);
                            transform: rotate(
                                            20deg
                            );
                            -webkit-transform: rotate(
                                            20deg
                            );
                            background: #5e94fa;
                        }
                        > div:nth-child(2){
                            position: absolute;
                            width: rem(2px);
                            height: rem(24px);
                            top: 0;
                            left: rem(4px);
                            -ms-transform: rotate(-20deg);
                            transform: rotate(
                                            -20deg
                            );
                            -webkit-transform: rotate(
                                            -20deg
                            );
                            background: #5e94fa;
                        }
                    }
                }
            }
            .target_price_content_chart{
                margin-bottom: rem(44px);
                .target_price_content_chart_pos_box{
                    transform: translate(-50%, 0);
                    left: 50%;
                    position: relative;
                }
                .target_price_content_chart_pos{
                    width: rem(32px);
                    height: rem(43px);
                    background: url("https://cdncos.aigupiao.com/assets/wap/img/znzg/pos.png");
                    background-size: 100%;
                    margin-bottom: rem(13px);
                    position: relative;
                    left: 80%;
                }
                .target_price_content_chart_wrap{
                    display: flex;
                    .target_price_content_chart_box{
                        width: 19.6%;
                        margin-right: rem(6px);
                        .target_price_content_chart_box_color{
                            height: rem(23px);
                            background: linear-gradient(90deg, #86E259 0%, #BFF27B 100%);
                            border-radius: rem(4px);
                        }
                        .color2{
                            background: linear-gradient(90deg, #B3ED58 0%, #DEE800 100%);
                        }
                        .color3{
                            background: linear-gradient(90deg, #FFD968 0%, #FFB04D 100%);
                        }
                        .color4{
                            background: linear-gradient(90deg, #FF9354 0%, #F87F58 100%);
                        }
                        .color5{
                            background: linear-gradient(90deg, #F66A3E 0%, #EA1B00 100%);
                        }
                        .target_price_content_chart_box_word{
                            height: rem(74px);
                            font-size: rem(22px);
                            font-weight: 400;
                            color: #939393;
                            line-height: rem(74px);
                            text-align: center;
                        }
                    }
                }
            }



            .grade_table{
                .grade_table_title{
                    width: 100%;
                    background: #F5F6F7;
                    height: rem(72px);
                    span{
                        width: 33.3%;
                        display: inline-block;
                        text-align: center;
                        font-size: rem(26px);
                        font-weight: 400;
                        color: #333333;
                        line-height: rem(72px);
                    }
                }

                ul{
                    li{
                        height: rem(85px);
                        border-bottom: 1px solid #EBEBEB;
                        span{
                            width: 33.3%;
                            display: inline-block;
                            text-align: center;
                            font-size: rem(26px);
                            font-weight: 400;
                            color: #636363;
                            line-height: rem(85px);
                        }
                        .grade_red{
                            color: #FE484A;
                        }
                        .grade_green{
                            color: #0AC890;
                        }
                        .grade_yellow{
                            color: #F68532;
                        }
                    }
                }
            }

            .technical_analysis{
                .technical_analysis_title{
                    font-size: rem(28px);
                    font-weight: 400;
                    color: #333333;
                    line-height: rem(40px);
                    margin-bottom: rem(20px);
                    img{
                        width: rem(10px);
                        margin-right: rem(6px);
                    }
                }
                .technical_analysis_box{
                    span{
                        padding: rem(9px) rem(16px);
                        background: #FEF4F4;
                        border-radius: 4px;
                        font-size: 26px;
                        font-weight: 400;
                        color: #FE484A;
                        line-height: rem(55px);
                        display: inline-block;
                        margin: rem(10px);
                    }
                    .down_span{
                        background: #E3F6F2;
                        color: #09BF99;
                    }
                    .hold_span{
                        background: #FFEEE1;
                        color: #DB8E5B
                    }
                }
            }

            .longhu{
                margin-bottom: rem(30px);
            }
            .longhu_box{

                .longhu_range{
                    display: flex;
                    height: rem(80px);
                    border-bottom: rem(1px) solid #EBEBEB;
                    border-top: rem(1px) solid #EBEBEB;
                    line-height: rem(80px);
                    justify-content: space-between;
                    font-size: rem(28px);
                    font-weight: 400;
                    color: #636363;
                    align-items: center;
                    margin-bottom: rem(17px);
                    img{
                        width: rem(26px);
                        margin-right: rem(10px);
                    }
                    .longhu_rise_red{
                        margin-left: rem(15px);
                        color: #FE484A;
                    }
                    .longhu_rise_green{
                        margin-left: rem(15px);
                        color: #0AC890;
                    }
                }


                .longhu_total{
                    display: flex;
                    margin-bottom: rem(30px);
                    > div{
                        width: 33.3%;
                        text-align: center;
                        font-size: rem(28px);
                        font-weight: 400;
                        color: #636363;

                        >p{
                            line-height: rem(60px);
                        }
                        .total_num{
                            font-size: rem(34px);
                            font-weight: 400;
                            color: #FE484A;
                            line-height: rem(48px);
                        }
                        .total_num_sell{
                            color: #448DFE;
                        }
                        .total_num_net{
                            color: #333333;
                        }
                    }
                }

                .longhu_reason{
                    padding: rem(16px);
                    background: #FFF7F1;
                    border-radius: 4px;
                    font-size: rem(26px);
                    font-weight: 400;
                    color: #F68532;
                    line-height: rem(37px);
                    margin-bottom: rem(40px);
                }
                .expand{
                    width: rem(85px);
                    margin: rem(35px) auto 0;
                    font-size: rem(24px);
                    font-weight: 400;
                    color: #939393;
                    line-height: rem(33px);
                    img{
                        width: rem(26px);
                        margin-right: rem(9px);
                    }
                }
                .longhu_table{
                    .longhu_table_title{
                        padding: 0 rem(16px);
                        display: flex;
                        height: rem(72px);
                        background: #F5F6F7;
                        font-size: rem(26px);
                        font-weight: 400;
                        color: #333333;
                        line-height: rem(72px);
                        div{
                            flex: 1;
                        }
                        .longhu_table_buy5{
                            flex: unset;
                            margin-right: rem(40px);
                        }
                    }
                    .longhu_table_sell{
                        text-align: right;
                    }
                    .longhu_table_buy5{
                        width: rem(344px);
                    }
                    ul{
                        padding: 0 rem(16px);
                        font-size: rem(26px);
                        font-weight: 400;
                        color: #636363;
                        line-height: rem(37px);
                        li{
                            display: flex;
                            height: rem(114px);
                            align-items: center;
                            border-bottom: rem(1px) solid #EBEBEB;
                            div{
                                flex: 1;
                            }
                            .longhu_table_buy5{
                                flex: unset;
                                margin-right: rem(40px);
                            }
                        }
                    }
                    .longhu_green{
                        color: #09BF99;
                    }
                    .longhu_red{
                        color: #FE484A;
                    }
                    .longhu_blue{
                        color: #448DFE;
                    }
                }


            }

        }

        .target_price_p{
            color:#333333;
            margin-bottom: 10px;
            
            >h1{
                font-weight: 500;
                font-size: 15px;
                line-height: 100%;

                >span{
                    font-weight: 400;
                    font-size: 12px;
                    line-height: 100%;
                    margin-left: 5px;
                    color:#939393;
                }
            }

            .plate_wrap{
                display: flex;
                flex-wrap: wrap;
                margin-top: 5px;

                
                .plate_i{
                    display: flex;
                    flex-direction: column;
                    margin-top: 6px;
                    align-items: center;
                    justify-content: center;
                    background: #F2F3F5;
                    margin-right: 6px;
                    width: 106px;
                    height: 70px;
                    border-radius: 4px;
                    position: relative;
                    box-sizing: border-box;

                    >i{
                        min-width: 36px;
                        height: 15px;
                        top: -5px;
                        right: -3px;
                        position: absolute;
                        padding-right: 5px;
                        padding-left: 5px;
                        border-top-left-radius: 4px;
                        border-top-right-radius: 4px;
                        border-bottom-right-radius: 4px;
                        box-sizing: border-box;
                        background: #FF443D;
                        font-weight: 400;
                        font-size: 10px;
                        line-height: 100%;
                        text-align: center;
                        color: #fff;
                        font-style: normal;
                        z-index: 1;
                        display: flex;
                        align-items: center;
                        white-space: nowrap;

                    }
                    >h1{
                        font-weight: 400;
                        font-size: 14px;
                        line-height: 100%;
                    }
                    >span{
                        font-weight: 500;
                        font-size: 15px;
                        line-height: 100%;
                        margin-left: 5px;
                        font-family: DINPro;
                        color: #7F8E9D;
                        margin-top: 5px;
                    }

                    &.red{
                        background: #FFF3F3;
                        >span{
                            color: #CB382D;
                        }
                    }

                    &.green{
                        background: #EFFAF3;
                        >span{
                            color: #659957;
                        }
                    }
                }

                .plate_i:nth-child(3n){
                    margin-right: 0;
                }
            }
        }

        .target_price_p2{
            color:#333333;
            background: #FAF9FE;
            border-radius: 4px;
            padding: 5px;
            font-weight: 400;
            font-size: 14px;
            line-height: 22px;
            margin-bottom: 20px;

            p{
                margin: 0 0 5px;
            }

            .red{
                background: #FF443D;
                padding: 1px 4px;
                color: #fff;
                margin-right: 5px;
                border-radius: 4px;
            }
        }



    }
    .company_box{
        background-color: #ffffff;
        overflow: auto;
        .grade_box{
            width: rem(694px);
            height: rem(257px);
            background: #FFFFFF;
            border-radius: rem(24px);
            margin: rem(35px) auto rem(50px);
            box-shadow: 0px rem(2px) rem(14px) 0px rgba(181, 181, 181, 0.5);
            display: flex;
            .company_chart{
                width: 56%;
            }
            .grade{
                width: 44%;
                border-left: rem(1px) solid #F1F1F1;
                text-align: center;
                .grade_name{
                    height: rem(40px);
                    font-size: rem(28px);
                    font-weight: 400;
                    color: #636363;
                    line-height: rem(40px);
                    margin-top: rem(38px);
                }
                .grade_number{
                    height: rem(101px);
                    font-size: rem(68px);
                    font-weight: 600;
                    color: #FE484A;
                    line-height: rem(101px);
                }
                .grade_word{
                    height: rem(42px);
                    font-size: rem(24px);
                    font-weight: 400;
                    color: #939393;
                    line-height: rem(33px);
                    span{
                        font-size: rem(30px);
                        color: #F68532;
                    }
                }
            }
        }
        .company_quality{
            margin-top: rem(50px);
            margin-bottom: rem(30px);
            padding: 0 rem(24px);
            .company_quality_title{
                height: rem(45px);
                margin-bottom: rem(20px);
                display: flex;
                align-items: center;
                img{
                    width: rem(33px);
                    margin-right: rem(9px);
                }
            }
            .company_quality_content{
                ul{
                    margin-left: rem(12px);
                    border-left:  rem(2px) dashed #979797;
                    padding-left: rem(28px);
                    li{
                        font-size: rem(30px);
                        font-weight: 400;
                        color: #333333;
                        line-height: rem(42px);
                        margin-bottom: rem(20px);
                        position: relative;
                        .point{
                            width: rem(18px);
                            height: rem(18px);
                            background: #FFFFFF;
                            border-radius: 50%;
                            border: rem(3px) solid #FF3939;
                            position: absolute;
                            left: rem(-41px);
                            transform: translate(0,-50%);
                            top: 50%;
                        }
                        .point_tag{
                            color: #FE484A;
                            font-size: rem(34px);
                        }
                        .blue{
                            border: rem(3px) solid #619EFF;
                        }
                    }
                }
                .company_tag{
                    margin-left: rem(42px);
                    padding: 0 rem(15px);
                    height: rem(40px);
                    background: #FF3939;
                    border-radius: rem(4px);
                    font-size: rem(24px);
                    font-weight: 400;
                    color: #FFFFFF;
                    line-height: rem(40px);
                    text-align: center;
                    display: inline-block;
                }
                .tag_blue{
                    background: #63A0FF;
                }
            }
        }
    }

    .risk_statement{
        width: 100%;
        height: rem(100px);
        background: #F5F6F7;
        font-size: rem(24px);
        font-weight: 400;
        color: #636363;
        line-height: rem(100px);
        text-align: center;
    }


    /* 通用样式  */
    .big_title_common{
        font-size: rem(32px);
        font-weight: 600;
        color: #333333;
        line-height: rem(45px);
    }
    .big_title_margin{
        display: inline-block;
        margin: rem(30px) 0 rem(20px);
    }

    /*  图表 */
    #company_chart{
        width: rem(390px);
        height: rem(256px);
    }

    #ratio_chart{
        width: rem(700px);
        height: rem(430px);
    }
    #financing_chart{
        width: rem(700px);
        height: rem(430px);
    }
    #k_chart{
        width: rem(700px);
        height: rem(250px);
    }
/*    html{
        touch-action: none;
    }*/
    .none{
        min-height: 100vh;
        background: #fff;
        .none_img{
            width: rem(590px);
            height: rem(448px);
            margin: rem(148px) auto rem(99px);
            img{
                width: 100%;
                height: 100%;
            }

        }
        p{
            height: rem(42px);
            font-size: rem(30px);
            color: #636363;
            line-height: rem(42px);
            text-align: center;
        }
    }

    .target_price_p2 font{
        display: inline-flex;
    }
</style>